<section
  class="subform"
  role="dialog"
  aria-modal="true"
  [class.subform-tall]="variant === 'tall'"
  [attr.aria-labelledby]="titleId"
>
  <header class="subform-head">
    <button
      type="button"
      class="subform-icon-btn subform-back"
      [attr.aria-label]="'Back to account settings' | translate"
      (click)="back.emit()"
    >
      <app-account-icon name="chevron-left"></app-account-icon>
    </button>
    <div class="subform-title">
      <span class="subform-crumb">{{ crumb }}</span>
      <h1 [id]="titleId">{{ title }}</h1>
    </div>
    <button
      type="button"
      class="subform-icon-btn subform-close"
      [attr.aria-label]="'Close' | translate"
      (click)="back.emit()"
    >
      <app-account-icon name="x"></app-account-icon>
    </button>
  </header>

  <div
    class="subform-body"
    [class.subform-body-tall]="variant === 'tall'"
    [class.subform-body-centered]="variant === 'centered'"
  >
    <ng-content></ng-content>
  </div>

  <footer class="subform-foot">
    <ng-content select="[subformFooter]"></ng-content>
  </footer>
</section>
